export default __webpack_public_path__ + "static/media/form-validation-password-error.2c6885e5.png";